import { onMounted, onBeforeUnmount } from "vue";

/**
 * Закрывает календарь при клике вне переданного триггера и вне .date-picker
 */
export function useClickOutsideCalendar(triggerRef, callback) {
    const handler = event => {
        const clicked = event.target;

        // 1) Если внутри кнопки-триггера — не закрываем
        const trigEl = triggerRef.value;
        if (trigEl && typeof trigEl.contains === "function" &&
            (trigEl === clicked || trigEl.contains(clicked))) {
            return;
        }

        // 2) Если внутри календаря (.date-picker) — не закрываем
        if (clicked instanceof Element &&
            clicked.closest(".date-picker")) {
            return;
        }

        // иначе — клик вне, закрываем
        callback(event);
    };

    onMounted(() => document.addEventListener("click", handler));
    onBeforeUnmount(() => document.removeEventListener("click", handler));
}
